
const COLOR_TYPES = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
});

export default COLOR_TYPES;
